import React from 'react';
import type {SystemStyleObject} from '@tempo/core';
import {Tooltip as TempoTooltip} from '@tempo/core';

type TempoTooltipProps = React.ComponentProps<typeof TempoTooltip>;

export type TooltipProps = TempoTooltipProps & {
	sx?: SystemStyleObject;
};

export function Tooltip({sx, ...rest}: TooltipProps) {
	return (
		<TempoTooltip
			{...rest}
			sx={{
				fontSize: 'sm',
				...sx,
			}}
		/>
	);
}

export default Tooltip;
